import axios from "axios";
import { GENERAL_URL_API } from "../../../urls";

/**
 * @returns {Promise<Array<Notibanner>>}
 */
export async function fetchFormularios() {
  const { data } = await axios.get(`${GENERAL_URL_API}/eventos/formularios/verFormulariosEventos`, {
    withCredentials: true,
  });

  return data.data;
}
